// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Styled from './PropertyItemsContainer.styles';

class PropertyItemsContainer extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  static defaultProps = {
    children: null
  };

  componentDidMount() {
    /* eslint-disable-next-line global-require */
    require('intersection-observer/intersection-observer');

    this.observer = new IntersectionObserver(images => {
      images.forEach(image => {
        if (!image.target.src && image.intersectionRatio > 0) {
          image.target.src = image.target.dataset.src;
          this.observer.unobserve(image.target);
        }
      });
    }, document.querySelector('.PropertyItemsContainer'));

    const images = document.querySelectorAll('.property-item-image');

    images.forEach(image => {
      this.observer.observe(image);
    });
  }

  componentDidUpdate() {
    // Observe new properties
    this.observer.disconnect();
    const images = document.querySelectorAll('.property-item-image');

    images.forEach(image => {
      if (!image.src) {
        this.observer.observe(image);
      }
    });
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  render() {
    const { children } = this.props;

    return <Styled.Container className="PropertyItemsContainer">{children}</Styled.Container>;
  }
}

export default PropertyItemsContainer;
